/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Short-lived presigned URL for an uploaded resume file.
 *
 * Returned by the pipeline resume endpoint. Resume objects are stored
 * privately in S3 — the UI must use this URL (not `source_file_url`) to
 * render or download the file.
 */
export interface ResumeUrlResponse {
  url: string;
  filename?: string | null;
  content_type?: string | null;
  expires_in?: number;
}
